
/**
 * Click to show
 *
 * @author Dylan James Wagner
 */
function init() {
  const clickGroups = document.querySelectorAll('.wp-block-group.is-style-collapsible');
  clickGroups.forEach((group) => {
    const groupInner = group.querySelector(':scope > .wp-block-group__inner-container');
    const groupHeadingInitial = groupInner.querySelector(':scope > h1:first-child, :scope > h2:first-child, :scope > h3:first-child, :scope > h4:first-child, :scope > h5:first-child, :scope > h6:first-child');

    if (groupHeadingInitial) {
      groupInner.innerHTML = '<div class="is-style-collapsible__inner">' + groupInner.innerHTML + '</div>';

      const groupContent = groupInner.querySelector(':scope > .is-style-collapsible__inner');

      const groupHeading = groupContent.querySelector(':scope > h1:first-child, :scope > h2:first-child, :scope > h3:first-child, :scope > h4:first-child, :scope > h5:first-child, :scope > h6:first-child');
      groupHeading.className = 'is-style-collapsible__heading';
      groupInner.prepend(groupHeading);

      groupContent.style.height = `${groupContent.clientHeight}px`;
      groupContent.setAttribute('aria-expanded', false);
      groupContent.setAttribute('aria-hidden', true);
      group.classList.add('is-style-collapsible--collapsed');

      window.addEventListener('resize', () => {
        if (group.classList.contains('is-style-collapsible--collapsed')) {
          group.classList.remove('is-style-collapsible--collapsed');
          groupContent.style.height = '';
          groupContent.style.height = `${groupContent.clientHeight}px`;
          group.classList.add('is-style-collapsible--collapsed');
        }
        else if (group.classList.contains('is-style-collapsible--expanded')) {
          group.classList.remove('is-style-collapsible--expanded');
          groupContent.style.height = '';
          groupContent.style.height = `${groupContent.clientHeight}px`;
          group.classList.add('is-style-collapsible--expanded');
        }
      });

      const groupToggle = document.createElement('button');
      groupToggle.className = 'is-style-collapsible__toggle';
      groupToggle.innerText = 'Click to Expand';
      groupToggle.setAttribute('aria-label', groupHeading.innerText + '; Click to Expand');
      groupHeading.prepend(groupToggle);

      groupToggle.addEventListener('click', () => {
        if (group.classList.contains('is-style-collapsible--collapsed')) {
          group.classList.add('is-style-collapsible--expanded');
          group.classList.remove('is-style-collapsible--collapsed');
          groupContent.setAttribute('aria-expanded', true);
          groupContent.setAttribute('aria-hidden', false);
          groupToggle.innerText = 'Click to Collapse';
          groupToggle.setAttribute('aria-label', groupToggle.getAttribute('aria-label').replace('Click to Expand', 'Click to Collapse'));
        }
        else if (group.classList.contains('is-style-collapsible--expanded')) {
          group.classList.add('is-style-collapsible--collapsed');
          group.classList.remove('is-style-collapsible--expanded');
          groupContent.setAttribute('aria-expanded', false);
          groupContent.setAttribute('aria-hidden', true);
          groupToggle.innerText = 'Click to Expand';
          groupToggle.setAttribute('aria-label', groupToggle.getAttribute('aria-label').replace('Click to Collapse', 'Click to Expand'));
        }
      });
    }
    else {
      group.classList.remove('is-style-collapsible', 'is-variation-collapsible-group');
    }
  });
}

export {init as default}
